/* eslint-disable max-len */

import React from "react"

import BaseSvgIcon from "./Base"

const Archive = (props) => (
  <BaseSvgIcon {...props} viewBox="0 0 19 16">
    <g id="UX-Specification-document" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Homepage_default_VD_Desktop-Copy" transform="translate(-1118.000000, -762.000000)" fill="#3D3D36" fillRule="nonzero">
        <g id="Group-12" transform="translate(1101.000000, 577.000000)">
          <g id="Group-20" transform="translate(17.000000, 185.000000)">
            <g id="Archive">
              <path
                d="M17.7764,0 L0.9196,0 C0.411718944,-3.10987455e-17 6.2197491e-17,0.411718944 0,0.9196 L0,2.66 C6.2197491e-17,3.16788106 0.411718944,3.5796 0.9196,3.5796 L1.6796,3.5796 L1.6796,14.3412 C1.6796,15.0001862 2.21381384,15.5344 2.8728,15.5344 L15.8536,15.5344 C16.5125862,15.5344 17.0468,15.0001862 17.0468,14.3412 L17.0468,3.5796 L17.8068,3.5796 C18.302771,3.56319537 18.6962712,3.15624215 18.696,2.66 L18.696,0.9196 C18.696,0.411718944 18.2842811,3.10987455e-17 17.7764,0 Z M16.0588,14.3412 C16.0588,14.4545288 15.9669288,14.5464 15.8536,14.5464 L2.8424,14.5464 C2.72907117,14.5464 2.6372,14.4545288 2.6372,14.3412 L2.6372,3.5796 L16.0588,3.5796 L16.0588,14.3412 Z M17.708,2.5916 L0.988,2.5916 L0.988,0.988 L17.708,0.988 L17.708,2.5916 Z"
                id="Shape"
              />
              <path
                d="M6.7564,7.8128 L11.9396,7.8128 C12.4715233,7.79716298 12.900224,7.37178551 12.92,6.84 L12.92,6.08 C12.9158621,5.52347357 12.4657264,5.07333791 11.9092,5.0692 L6.7564,5.0692 C6.19815057,5.0692 5.7456,5.52175057 5.7456,6.08 L5.7456,6.84 C5.76210841,7.38510852 6.21105916,7.81718142 6.7564,7.8128 Z M6.7564,6.0344 L11.9624,6.0344 L11.9624,6.84 L6.7336,6.84 L6.7564,6.0344 Z"
                id="Shape"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </BaseSvgIcon>
)

export default Archive
